import { render, staticRenderFns } from "./servicefacelist.vue?vue&type=template&id=2a99c83e&scoped=true&"
import script from "./servicefacelist.vue?vue&type=script&lang=js&"
export * from "./servicefacelist.vue?vue&type=script&lang=js&"
import style0 from "./servicefacelist.vue?vue&type=style&index=0&id=2a99c83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99c83e",
  null
  
)

export default component.exports